import React from 'react';
import Icon from '../../atoms/Icon';
import './ActivityItem.css';

interface ActivityItemProps {
  type: 'order' | 'product' | 'customer';
  title: string;
  description: string;
  time: string;
}

const ActivityItem: React.FC<ActivityItemProps> = ({ 
  type, 
  title, 
  description, 
  time 
}) => {
  const getIconType = () => {
    switch (type) {
      case 'order':
        return 'cart';
      case 'product':
        return 'cake';
      case 'customer':
        return 'user';
      default:
        return 'cart';
    }
  };

  return (
    <div className="activity-item">
      <div className={`activity-icon ${type}`}>
        <Icon type={getIconType()} size="small" />
      </div>
      <div className="activity-content">
        <p><strong>{title}</strong> {description}</p>
        <span className="activity-time">{time}</span>
      </div>
    </div>
  );
};

export default ActivityItem;
